<template>
  <div class="waller-record-list">
    <div class="title">
      <div class="icon">
        <van-icon name="list-switch" color="#9e8675" size="28" />
      </div>
      <div class="text">资产明细</div>
    </div>
    <div class="list-box">
      <div v-if="list && list.length > 0">
        <div v-for="(item, index) in list" :key="index">
          <div class="items">
            <div class="icon" :class="item.st == 1 ? 'icon-in' : 'icon-out'">
              <van-icon
                :name="item.st == 1 ? 'add-o' : 'close'"
                color="#fff"
                size="28"
                style="margin: 6px"
              />
            </div>
            <div class="record-info">
              <p>{{ item.type == 1 ? '充值' : '提现' }}</p>
              <span>{{ item.addtime }}</span>
            </div>
            <div class="record-money">
              <p :class="item.st == 1 ? 'in' : 'out'">
                {{ item.st == 1 ? '+' : '-' }}￥{{ item.num }}
              </p>
              <div
                v-if=" (item.status != 3 || (item.status == 3 && item.remark && item.remark.length > 0))"
                :class="
                  item.status == 1
                    ? 'wait'
                    : item.status == 2 || item.type == 1
                    ? 'pass'
                    : item.status == 3
                    ? 'error'
                    : ''
                "
              >
                {{ item.status == 1
                    ? '待审核'
                    : item.status == 2
                    ? '审核通过'
                    : '' }} {{ item.remark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list && list.length == 0" class="no-data">
        <van-empty description="暂无记录" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WallerRecordView',
  data () {
    return {
      isrefresh: false,
      loading: false,
      finished: false,
      list: null,
      usrData: null
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    async onLoad () {
      await this.$http({
        method: 'post',
        url: 'stream'
      })
        .then(res => {
          this.loading = false
          this.isrefresh = false
          if (!this.list) this.list = res.data
          else {
            this.list = this.list.concat(res.data)
          }
          if (this.list.length >= res.data.pagination.count) {
            this.finished = true
          } else {
            this.page += 1
          }
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.waller-record-list {
  margin: -20px 10px 20px;
  border-radius: 10px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .title {
    background: #fdf6ee;
    height: 38px;
    line-height: 38px;
    padding: 10px;
    display: flex;
    gap: 8px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom: 1px solid #f6f4ef;
    .icon {
      width: 33px;
      margin-top: 5px;
    }
    .text {
      color: #43322e;
      font-size: 18px;
      font-weight: 600;
    }
  }
  .list-box {
    background: #fefffa;
    min-height: calc(100vh - 450px);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .items {
      display: flex;
      gap: 8px;
      padding: 10px;
      .icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        text-align: center;
      }
      .record-info {
        flex: 4;
        p {
          font-size: 16px;
          font-weight: 600;
        }
        span {
          font-size: 14px;
          color: #969799;
        }
      }
      .record-money {
        flex: 4;
        text-align: right;
        p {
          font-size: 16px;
          font-weight: 600;
        }
        p.in {
          color: #754420;
          line-height: 40px;
        }
        p.out {
          color: #ae8f65;
        }
        .error {
          font-size: 12px;
          color: #a54b4e;
          background: #f3c7c6;
          border: 1px solid #a54b4e;
          float: right;
          padding: 2px 4px;
          border-radius: 4px;
        }
        .wait {
          font-size: 12px;
          color: #97725e;
          background: #e4d9cd;
          border: 1px solid #97725e;
          float: right;
          padding: 2px 4px;
          border-radius: 4px;
        }
        .pass {
          font-size: 12px;
          color: #07c160;
          background: #b5e1b0;
          border: 1px solid #07c160;
          float: right;
          padding: 2px 4px;
          border-radius: 4px;
        }
      }
    }
  }
}
.icon-out {
  background: linear-gradient(135deg, #d4bc96, #ddb17e);
}
.icon-in {
  background: linear-gradient(135deg, #9c6d48, #bf9a71);
}
</style>
